
import { useEffect, useRef } from 'react'

export const useResetDependentFields = (
  formik,
  triggerField,
  validValues,
  dependentFields
) => {
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    if (!validValues.includes(formik.values[triggerField])) {
      dependentFields.forEach((field) => {
        formik.setFieldValue(field, '', false)
        formik.setFieldTouched(field, false, false)
        formik.setFieldError(field, undefined)
      })
    }
  }, [formik.values[triggerField]])
}

export const useResetDependentFields2 = (
  formik,
  triggerField,
  validValues,
  dependentFields
) => {
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    if (validValues.includes(formik.values[triggerField])) {
      dependentFields.forEach((field) => {
        formik.setFieldValue(field, '', false)
        formik.setFieldTouched(field, false, false)
        formik.setFieldError(field, undefined)
      })
    }
  }, [formik.values[triggerField]])
}